import { render } from "./ShopContent.vue?vue&type=template&id=9bb4bc08&scoped=true"
import script from "./ShopContent.vue?vue&type=script&lang=js"
export * from "./ShopContent.vue?vue&type=script&lang=js"

import "./ShopContent.vue?vue&type=style&index=0&id=9bb4bc08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb4bc08"]])

export default __exports__